import * as React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {withAppStores} from "../../../../../AppStores";
import type {AppState} from "../../../../../data/state/AppState";
import type {TransportLayer} from "../../../../../data/TransportLayer";
import type {CreatePortfolioPermissionSetRequest} from "../../../../../generated/api/base";
import type {PermissionSet} from "../../../../../data/models/permission/PermissionSet";
import {XyiconFeature} from "../../../../../generated/api/base";
import {ButtonStyled, ButtonV5} from "../../../button/ButtonV5";
import {baseDistance, VerticalFlexStyle} from "../../../styles/styles";
import {TextInputV5} from "../../../details/datatypes/TextInputV5";
import {GeneralPermissionsV5} from "./GeneralPermissionsV5";

interface ICreatePermissionSetPanelProps {
	readonly onClose: (createdId?: string) => void;
	readonly appState?: AppState;
	readonly transport?: TransportLayer;
}

interface ICreatePermissionSetPanelState {
	name: string;
	isSaving: boolean;
}

@withAppStores("appState", "transport")
@observer
export class CreatePermissionSetPanelV5 extends React.PureComponent<ICreatePermissionSetPanelProps, ICreatePermissionSetPanelState> {
	constructor(props: ICreatePermissionSetPanelProps) {
		super(props);
		this.state = {
			name: "",
			isSaving: false,
		};
	}

	private onCreateClicked = async () => {
		this.setState({isSaving: true});

		const {name} = this.state;

		const data: CreatePortfolioPermissionSetRequest = {
			name: name,
			portfolioFieldPermissions: [],
			portfolioPermission: GeneralPermissionsV5.generalPermissionOptions[0].id,
			featurePermissions: [],
		};
		const models = await this.props.transport.services.feature.create<PermissionSet>(data, XyiconFeature.PermissionSet);

		this.setState({
			isSaving: true,
			name: "",
		});

		this.props.onClose(models?.[0]?.id);
	};

	private isNameValid = (name: string) => {
		return this.props.appState.actions.isPermissionSetNameValid(name, "");
	};

	private getErrorMessage = (name: string) => {
		return !name.trim() ? "Name cannot be empty!" : this.isNameValid(name) ? "" : "Name needs to be unique!";
	};

	private onTextInput = (value: string) => {
		this.setState({name: value});
	};

	public override render() {
		const {name, isSaving} = this.state;
		const isFormValid = name && this.isNameValid(name);

		return (
			<PermissionCreatePanelStyled>
				<TextInputV5
					value={name}
					getErrorMessage={this.getErrorMessage}
					placeholder="Name Value"
					autoFocus={true}
					onInput={this.onTextInput}
				/>
				<ButtonV5
					label={isSaving ? "Saving..." : "Confirm"}
					title="Create"
					onClick={this.onCreateClicked}
					disabled={!isFormValid || isSaving}
				/>
			</PermissionCreatePanelStyled>
		);
	}
}

export const PermissionCreatePanelStyled = styled.div`
	${VerticalFlexStyle};
	gap: ${baseDistance.md};

	${ButtonStyled} {
		align-self: flex-end;
	}
`;
